import angular from 'angular';

class containerPlatformCtrl {
  /* @ngInject */
  constructor() {}

  // Annulation de la sauvegarde.
  cancel() {
    this.modalInstance.dismiss();
  }

  // Confirmation de la creation des repertoires d'echange avec la plateforme de demat.
  confirmSubmit() {
    this.modalInstance.close();
  }
}

angular.module('principal').component('containerPlatform', {
  templateUrl: require('./container-platform-popup.html'),
  controller: containerPlatformCtrl,
  bindings: {
    container: '<',
    modalInstance: '<'
  }
});
